module.exports = __webpack_public_path__ + "img/Robinsons.d53774e0.png";